import Vue from "vue";
import store from "../store/store.js";
import VueRouter from "vue-router";
import routes from "../routes";
import { Role } from "./_helper";

function lazyLoad(view){
  return() => import(/* webpackChunkName: "[request]" */ `@/views/${view}.vue`)
}
function lazyLoadComponent(view){
  return() => import(/* webpackChunkName: "[request]" */ `@/components/${view}.vue`)
}

Vue.use(VueRouter);

const all_routes = routes.concat([
  {
    path: '/',
    name: 'home',
    redirect: '/account-info',
    meta: { authorize: [Role.Admin, Role.ManageSettings, Role.ManageUsers], requiresAuth: true } 
  },
  {
    path: '/accounts',
    name: 'Accounts',
    component: lazyLoad('Accounts'),
    meta: { authorize: [Role.Super], requiresAuth: true } 
  },
  {
    path: '/secure/account/:id',
    name: 'AccountDetail',
    component: lazyLoad('AccountDetail'),
    meta: { authorize: [Role.Admin, Role.ManageSettings] } 
  },
  // {
  //   path: '/users',
  //   name: 'Users',
  //   component: lazyLoad('Users'),
  //   meta: { authorize: [Role.Admin], requiresAuth: true } 
  // },
  // {
  //   path: '/user/:id?',
  //   name: 'User',
  //   component: lazyLoad('User'),
  //   meta: { authorize: [Role.Admin], requiresAuth: true } 
  // },
  {
    path: "/settings/email",
    name: "EmailSettings",
    component: lazyLoad('EmailSettings'),
    meta: { authorize: [Role.Admin, Role.ManageSettings], requiresAuth: true } 
  },
  {
    path: '/account-info',
    name: 'AccountInfo',
    component: lazyLoad('AccountInfo'),
    meta: { authorize: [Role.Admin, Role.ManageSettings], requiresAuth: true } 
  },
  {
    path: '/secure/new-account',
    name: 'NewAccount',
    component: lazyLoad('NewAccount'),
    meta: { authorize: [Role.Super], requiresAuth: true } 
  },
  {
    path: "/login",
    name: "Login",
    component: lazyLoadComponent("auth/Login"),
    meta: { authorize: [] },
  },
  {
    path: "/secure/reset/password",
    name: "ResetPassword",
    component: lazyLoad("secure/ResetPassword"),
    meta: { authorize: [] },
  },
]);


const router = new VueRouter({
  routes: all_routes,
});

function isAuthorized(authorize){
  if(!authorize || authorize.length < 1){
    return true;
  }

  let hasModule = false;
  const userModules = store.getters['auth/userModules'];
  if(userModules && userModules.length > 0){
    hasModule = userModules.some(m => m && m.path === process.env.VUE_APP_MODULE);
  }

  const userRoles = store.getters['auth/userRoles'];
  if(hasModule && userRoles && userRoles.length > 0){
    return userRoles.some(r => authorize.includes(r));
  }
  else{
    store.dispatch("messages/addErrorMessage", 'Unauthorized Access', {root:true});
    return false;
  }

}

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.path.startsWith('/secure/') || record.meta.requiresAuth)) {
    const { authorize } = to.meta;

    if (store.getters['auth/isLoggedIn']) {
      //is logged in and has authorized permission
      if(isAuthorized(authorize)){
        next()
        return
      }
      else{
        //Is logged in, but not authorized
        store.dispatch("auth/processLogout", null, {root:true});
        next('/login')
      }
    }
    //not logged in
    else{
      //Check if jwt token exists and attempt to automatically log in
      store.dispatch("auth/remoteJwtTokenCheck", null, {root:true})
        .then( () => {
          //check if user is authorized
          if(isAuthorized(authorize)){
            next()
          }
          else{
            //not authorized
            store.dispatch("auth/processLogout", null, {root:true});
            next('/login')
          }
        })
        .catch( () => {
          // console.log('fail jwt token check')
          store.dispatch("auth/processLogout", null, {root:true});
          next('/login') 
        })
    }
  } else {
    //accessing non-secured page
    next()
  }
})

export default router;
